import { FC } from 'react';
import { createPortal } from 'react-dom';

import { DragOverlay, DragOverlayProps } from '@dnd-kit/core';
import { AnimatePresence } from 'framer-motion';

export const PortalDragOverlay: FC<DragOverlayProps> = ({ children, style, ...rest }) => {
  return createPortal(
    <DragOverlay {...rest} style={{ zIndex: 10001, ...style }}>
      <AnimatePresence>{children}</AnimatePresence>
    </DragOverlay>,
    document.body
  );
};
